import { Reveal } from "@/components/Reveal";

const SECTIONS = [
  {
    title: "1. हम कौन-सी जानकारी लेते हैं",
    body: "Pre-booking और account बनाने पर हम आपका नाम, email address, phone number और booking details (model, variant, colour, test drive preference) लेते हैं। Account के लिए आपका password सुरक्षित रूप से encrypt (bcrypt hash) करके store होता है — कोई भी उसे पढ़ नहीं सकता।",
  },
  {
    title: "2. जानकारी का उपयोग",
    body: "आपकी जानकारी सिर्फ़ इन कामों के लिए इस्तेमाल होती है: booking confirm करना, booking reference और status देना, test drive की तारीख़ तय करना, delivery updates भेजना और refund process करना। हम आपकी जानकारी किसी को बेचते नहीं।",
  },
  {
    title: "3. Payments — Razorpay",
    body: "₹10,000 token payment Razorpay (PCI-DSS compliant payment gateway) के ज़रिए process होती है। आपके card, UPI या netbanking के details हमारे servers पर store नहीं होते — यह पूरी तरह Razorpay के secure gateway में रहती है। हमें सिर्फ़ payment का status (success/fail) और payment reference मिलता है।",
  },
  {
    title: "4. Cookies और login session",
    body: "Login रखने के लिए हम httpOnly cookies इस्तेमाल करते हैं (access + refresh token)। ये cookies सिर्फ़ आपकी session verify करने के काम आती हैं और JavaScript से पढ़ी नहीं जा सकतीं।",
  },
  {
    title: "5. Data security",
    body: "आपका data encrypted connection (HTTPS) से transfer होता है। Passwords bcrypt से hashed रहते हैं, payment details हमारे पास आती ही नहीं, और database तक पहुँच सिर्फ़ authorized systems को है।",
  },
  {
    title: "6. आपके अधिकार",
    body: "आप कभी भी अपनी जानकारी देखने, सही कराने या delete कराने के लिए support@ishukart.com पर email कर सकते हैं। Account delete करने पर आपकी personal जानकारी 30 दिनों में हटा दी जाती है — सिवाय उस रिकॉर्ड के जो कानूनी रूप से रखना ज़रूरी हो।",
  },
  {
    title: "7. Grievance officer",
    body: "Privacy से जुड़ी किसी भी शिकायत के लिए support@ishukart.com पर email करें — विषय में 'Privacy' लिखें। हम 30 दिनों के भीतर समाधान के लिए प्रतिबद्ध हैं।",
  },
];

export default function PrivacyPolicy() {
  return (
    <div className="mx-auto max-w-3xl px-5 pb-24 pt-40 sm:px-8" data-testid="privacy-policy-page">
      <Reveal className="text-center">
        <p className="eyebrow">Legal</p>
        <h1 className="mt-4 font-display text-4xl font-extrabold uppercase text-white sm:text-5xl">
          Privacy <span className="text-gold-gradient">Policy</span>
        </h1>
        <p className="mt-4 text-xs uppercase tracking-[0.2em] text-neutral-500">Last updated: October 2026</p>
      </Reveal>

      <div className="mt-14 space-y-5">
        {SECTIONS.map((s) => (
          <Reveal key={s.title}>
            <div className="rounded-2xl border border-white/10 bg-[#0a0a0e] p-7">
              <h2 className="font-display text-lg font-bold uppercase text-white">{s.title}</h2>
              <p className="mt-3 text-sm leading-relaxed text-neutral-400">{s.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
